import React from 'react';
import clsx from 'clsx';

import './index.scss';

import BasicCheckBoxInput from 'components/atoms/Input/BasicCheckBoxInput';
import RadioInput from 'components/atoms/Input/RadioInput';

import RequiredOrOptionalIcon from 'components/atoms/Icon/RequiredOrOptionalIcon';

const SpAccordionCheckBox = ({
    // radio
    value,
    label,
    onChange,
    checked,
    id,

    // checkList
    title,
    list = [],
    require
}) => {
    const CheckList = ({ list: detail }) => {
        return (
            <div className="">
                {detail.map(data => (
                    <span className="checkList">
                        <BasicCheckBoxInput value={data.value} onChange={data.checkBoxOnChange} checked={data.checked} label={data.label} id={data.id} />
                    </span>
                )
                )}
            </div>
        )
    };

    return (

        <div className="SpAccordionCheckBox">
            <div className="sp-accordion-text-area-wrapper">
                <RadioInput id={id} value={value} onChange={onChange} checked={checked} label={label} />

                <div className={clsx('sp-cmnt-area', { checked })}>
                    <div className="arrowArea">
                        <div className="sp-background-cmnt" />
                    </div>

                    <div className="spCollpseAreaBackground">
                        <div>
                            {title}
                            <RequiredOrOptionalIcon label={require} />
                        </div>
                        <CheckList list={list} />
                    </div>
                </div>
            </div>
        </div>

    );
};

export default SpAccordionCheckBox;